import { ilReplaceDynamicPlaceholders } from './blocks/helpers';

const applyDynamicPlaceholderText = (root = document) => {
    if (!root?.querySelectorAll) {
        return;
    }

    root.querySelectorAll('[data-il-dynamic-text="1"]').forEach((element) => {
        const originalValue = element.getAttribute('data-il-dynamic-original');
        const sourceValue = originalValue ?? element.innerHTML;

        if (originalValue === null) {
            element.setAttribute('data-il-dynamic-original', sourceValue);
        }

        element.innerHTML = ilReplaceDynamicPlaceholders(sourceValue);
    });
};

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => applyDynamicPlaceholderText());
    } else {
        applyDynamicPlaceholderText();
    }
}

export default applyDynamicPlaceholderText;